import NAME from "./constants";

export const getFiltersIsLoading = store => store[NAME].loading;
export const getFilters = store => store[NAME].filters;